<div class="pnl-settings-banner">
  <header>
      <a [routerLink]="['/app/configuracao/design']" class="back">Design da loja</a>
      <h1>Banner rotativo</h1>
      <a [routerLink]="['/app/configuracao/design/banner-rotativo-cadastro']" class="add">Cadastrar</a>
  </header>
  <section>
    <div *ngIf="banners.length > 0" class="banner-actions">
      <div>
        <mat-checkbox [(ngModel)]="allSelected" (change)="onSelectAll()">Selecionar todos</mat-checkbox>
      </div>

      <div>
        <button (click)="onDeleteBanner()" class="btn" [class.btn-danger-outline]="canDelete" [disabled]="!canDelete">Apagar</button>
      </div>
    </div>
    <div cdkDropList class="banner-list" (cdkDropListDropped)="drop($event)">
        <div class="banner-box" *ngFor="let banner of banners; let i=index" cdkDrag [class.banner-box-disabled]="false">
          <div class="banner-ck">
            <mat-checkbox [(ngModel)]="banner.selected" (change)="onSelect()"></mat-checkbox>
          </div>
          <div class="cdkDragHandle" cdkDragHandle [class.selected]="banner.selected"><i class="ic ic-dots"></i></div>
          <div class="banner-custom-placeholder" *cdkDragPlaceholder></div>
          <div [routerLink]="['/app/configuracao/design/banner-rotativo-cadastro/'+banner.idbanner]" class="banner-data" [class.selected]="banner.selected">
            <div class="banner-infos">
              <strong>{{ banner.titulo == null ? 'Banner sem título' : banner.titulo }}</strong>
              <span *ngIf="banner.posicao">{{ banner.posicao }} posição</span>
            </div>
            <div class="banner-right">
              <div class="banner-status">
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days > 1">Expira em {{banner.dt_expiracao_days}} dias</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == 1">Expira Amanhã</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == 0">Expira Hoje</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == -1">Expirado</span>
                <span *ngIf="banner.diasemana != 0">{{getDayWeek(banner.diasemana)}}</span>
                <span class="tag tag-on" *ngIf="banner.publicado=='S'">Publicado</span>
                <span class="tag" *ngIf="banner.publicado=='N'">Inativo</span>
              </div>
            </div>
          </div>
        </div>
    </div>
  </section>

  <div class="loading" *ngIf="loadingBanner">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
  </div>
</div>
